var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"px-3",attrs:{"loading":_vm.loading}},[_c('v-card-title',[_vm._v(" "+_vm._s(this.title)+" ")]),_c('v-card-subtitle',{staticClass:"text-caption"},[_vm._v(" "+_vm._s(this.subtitle)+" ")]),_c('v-card-text',{staticClass:"body-1"},[_vm._v(" "+_vm._s(this.body)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }